import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"topbar_"},[_c(VRow,{attrs:{"no-gutters":""}},[_c(VCol,{staticClass:"text-center",attrs:{"cols":"12","sm":"12"}},[_c('h1',[_vm._v(_vm._s(_vm.headline))])])],1),_c(VRow,[(_vm.hasSubtitle)?_c(VCol,{staticClass:"text-center",attrs:{"cols":"12","sm":"12"}},[_c('div',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.subtitle))])]):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }